import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isLoadingSubject.asObservable();

  constructor() {}

  public show(): void {
    this.isLoadingSubject.next(true);
  }

  public hide(): void {
    this.isLoadingSubject.next(false);
  }
}
